import mutations from './mutations';
import api from '../api';

export default {
  namespaced: true,
  state: {
    loading: false,
    departments: [],
    status: null
  },
  mutations: {
    [mutations.LOADING](state) {
      state.loading = true;
    },
    [mutations.LOADED](state) {
      state.loading = false;
    }
  },
  actions: {
    getAll({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.department
        .getAll(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    detail({ commit }, id) {
      commit(mutations.LOADING);
      return api.department
        .detail(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    create({ commit }, payload) {
      commit(mutations.LOADING);
      return api.department
        .create(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    update({ commit }, { id, params }) {
      commit(mutations.LOADING);
      return api.department
        .update(id, params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    delete({ commit }, id) {
      commit(mutations.LOADING);
      return api.department
        .delete(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    }
  },
  getters: {}
};
